module.exports = __webpack_public_path__ + "img/oldTwoFalse.701d7fff.png";